import { render } from "./RiskySearchFromPage.vue?vue&type=template&id=6286497d"
import script from "./RiskySearchFromPage.vue?vue&type=script&lang=js"
export * from "./RiskySearchFromPage.vue?vue&type=script&lang=js"

import "./RiskySearchFromPage.vue?vue&type=style&index=0&id=6286497d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__